import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { useSite } from "../context/SiteContext";

export const Process = () => {
  const { process: p } = useSite();
  return (
  <section id="process" data-testid="process-section" className="bg-ink py-24 text-sand sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-6 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <Eyebrow light>How We Work</Eyebrow>
          <h2 className="font-display text-4xl leading-[1.08] sm:text-5xl">{p.title}</h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="text-base leading-relaxed text-sand/80 sm:text-lg">{p.text}</p>
        </Reveal>
      </div>
      <ol className="mt-16 grid gap-px overflow-hidden rounded-[20px] bg-sand/15 sm:grid-cols-2 lg:grid-cols-4">
        {p.steps.map((s, i) => (
          <Reveal key={i} delay={i * 0.1} className="h-full">
            <motion.li whileHover={{ backgroundColor: "#1E4436" }} className="flex h-full flex-col bg-ink p-7 sm:p-8" data-testid={`process-step-${i}`}>
              <span className="grid h-11 w-11 place-items-center rounded-full border border-clay-soft/60 font-display text-sm text-clay-soft">0{i + 1}</span>
              <h3 className="mt-10 font-display text-xl">{s.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-sand/75">{s.text}</p>
            </motion.li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
  );
};
